import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  OMDbContent: null,
  readContent: null,
  listenContent: null,
  devotionContent: null,
  playContent: null,
};

export const apiContent = createSlice({
  name: "apiContent",
  initialState,
  reducers: {
    setOMDbContent: (state, action) => {
      state.OMDbContent = action.payload;
    },
    setReadContent: (state, action) => {
      state.readContent = action.payload;
    },
    setListenContent: (state, action) => {
      state.listenContent = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setOMDbContent, setReadContent, setListenContent } =
  apiContent.actions;

export default apiContent.reducer;
